module.exports = __webpack_public_path__ + "img/spices.50f743b1.jpg";